Element.prototype.ariaToggle = Element.prototype.ariaToggle || function (property) {
    this.setAttribute(property, this.getAttribute(property) === 'false' ? 'true' : 'false');
};